<template>
     <transition name="modal">
		<div class="modal-mask modal-no-background " @click="$emit('close')">
			<div class="modal-wrapper" role="document" style="overflow-y:auto;position:absolute">
				<div class="modal-container">
					<div class="modal-content" @click.stop style="padding-top: 15px;padding-bottom: 15px;">
						<div class="modal-header" style="position:relative;">
							<slot name="close">
                                <a href="javascript:void(0)" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
									<vue-simple-svg
                                    :filepath="'/static/img/assets/_global/Close.svg'"
                                    width="50px"
                                    height="auto"
                                    class="icon"
                                    />
								</a>
                            </slot>
							
						</div>
						<div class="modal-body">
                            <slot name="body"></slot>
						</div>
					</div>
				</div>
			</div>
		</div>
    </transition>
</template>

<script>
    export default {
      mounted: function () {
          document.addEventListener('keydown', (e) => {
              if (e.keyCode == 27) {
                  vm.$emit('close')
                }
            })
    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/ModalBlank.vue